// extracted by mini-css-extract-plugin
export default {"Reset":"Reset_Reset__bXTBC","ResetButton":"Reset_ResetButton__Nyfh9"};